window.extract_quill_text = function(html) {
  if (!html) return "";
  if (typeof $ === "undefined") {
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const ql = temp.querySelector(".ql-editor");
      return (ql ? ql.textContent : temp.textContent).trim();
  }
  const $temp = $(`<div>${html}</div>`);
  if ($temp.find(".ql-editor").length) return $temp.find(".ql-editor").text().trim();
  return $temp.text().trim();
};

// Automatically make .tab-selector elements horizontally scrollable with arrows
document.addEventListener('DOMContentLoaded', () => {
    function initTabScroll(selector) {
        if (selector.classList.contains('scroll-initialized')) return;
        selector.classList.add('scroll-initialized');
        
        const wrapper = document.createElement('div');
        wrapper.className = 'tab-selector-wrapper';
        wrapper.style.position = 'relative';
        wrapper.style.display = window.getComputedStyle(selector).display === 'flex' ? 'flex' : 'inline-block';
        wrapper.style.maxWidth = '100%';
        wrapper.style.width = '100%';
        
        selector.parentNode.insertBefore(wrapper, selector);
        wrapper.appendChild(selector);
        
        // Force horizontal layout and allow scrolling
        selector.style.flexWrap = 'nowrap';
        selector.style.overflowX = 'auto';
        selector.style.maxWidth = '100%';
        
        const createArrow = (isLeft) => {
            const btn = document.createElement('div');
            btn.innerHTML = isLeft 
                ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
                : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
            btn.className = `tab-scroll-arrow ${isLeft ? 'left' : 'right'}-arrow`;
            btn.style.cssText = `
                position: absolute;
                ${isLeft ? 'left: -12px;' : 'right: -12px;'}
                top: 50%;
                transform: translateY(-50%);
                background: white;
                border: 2px solid black;
                border-radius: 50%;
                width: 26px;
                height: 26px;
                display: none;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 10;
                box-shadow: 2px 2px 0 rgba(0,0,0,1);
            `;
            return btn;
        };

        const leftArrow = createArrow(true);
        const rightArrow = createArrow(false);
        
        wrapper.appendChild(leftArrow);
        wrapper.appendChild(rightArrow);

        if (!document.getElementById('tab-scroll-style-global')) {
            const style = document.createElement('style');
            style.id = 'tab-scroll-style-global';
            style.innerHTML = '.tab-selector::-webkit-scrollbar { display: none !important; } .tab-selector { -ms-overflow-style: none; scrollbar-width: none; }';
            document.head.appendChild(style);
        }

        const updateArrows = () => {
            if (selector.scrollWidth > selector.clientWidth + 1) {
                leftArrow.style.display = selector.scrollLeft > 0 ? 'flex' : 'none';
                rightArrow.style.display = Math.ceil(selector.scrollLeft) < (selector.scrollWidth - selector.clientWidth - 1) ? 'flex' : 'none';
            } else {
                leftArrow.style.display = 'none';
                rightArrow.style.display = 'none';
            }
        };

        selector.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        
        const observer = new MutationObserver(updateArrows);
        observer.observe(selector, { childList: true, subtree: true, characterData: true });

        leftArrow.addEventListener('click', () => {
            selector.scrollBy({ left: -200, behavior: 'smooth' });
        });
        rightArrow.addEventListener('click', () => {
            selector.scrollBy({ left: 200, behavior: 'smooth' });
        });
        
        setTimeout(updateArrows, 100);
        setTimeout(updateArrows, 500);
    }

    document.querySelectorAll('.tab-selector').forEach(initTabScroll);

    const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    if (node.classList && node.classList.contains('tab-selector')) {
                        initTabScroll(node);
                    }
                    if (node.querySelectorAll) {
                        node.querySelectorAll('.tab-selector').forEach(initTabScroll);
                    }
                }
            });
        });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
});
